import React from 'react';
import { SectionHead } from '../../../../components/SectionHead/SectionHead';
import { CardsSlider } from '../../../../components/CardsSlider';
import './CardsSection.scss';
import { useFilteredCards } from '../../../Cards/hooks/useFilteredCards';

export function CardsSection({ data }) {
  const { content, filter, type, title, react_route } = data;
  const cards = useFilteredCards(content, filter);

  if(!cards.length) {
    return null;
  }

  return (
    <div className="CardsSection">
      <SectionHead
        titleUppercase
        title={title}
        action={{
          type: 'link',
          children: 'Show more',
          route: react_route
        }}
      />

      <CardsSlider
        isShowDate={type === 'cards_class'}
        isShowWatchLater={false}
        type={type === 'cards_class' || type === 'cards_class_series' ? 'classes' : 'courses'}
        cards={cards}
        limit={20}
        title={title}
      />
    </div>
  );
}
